import apiClient from '../apiClient';
import { GET_ACCOMODATION_TEMPLATE } from '../apiUrl';

const getTemplateAccomodationProfileApi = () => {
  return apiClient.get(GET_ACCOMODATION_TEMPLATE);
};

export default getTemplateAccomodationProfileApi;
